import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/visaService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class VisaForm extends Form {
  state = {
    expiryDate: new Date(),
    passportExpiryDate: new Date(),
    daily_salary_options: [
      { id: "", name: "Select option" },
      { id: 0, name: "No" },
      { id: 1, name: "Yes" },
    ],
    salary_type_options: [
      { id: "", name: "Select option" },
      { id: "fixed", name: "Fixed" },
      { id: "hourly", name: "Hourly" },
    ],
    report_link_options: [
      { id: "", name: "Select option" },
      { id: "yes", name: "Yes" },
      { id: "no", name: "No" },
    ],
    show_in_ledger_when_close_options: [
      { id: "", name: "Select option" },
      { id: 1, name: "Yes" },
      { id: 0, name: "No" },
    ],
    expiry_duration_options: [
      { id: "", name: "Select option" },
      { id: "one-year", name: "One Year" },
      { id: "two-year", name: "Two Year" },
      { id: "three-year", name: "Three Year" },
    ],
    data: {
      cost: "",
      passport_number: "",
      identification_id: "",
      mobile: "",
      name: "",
      ref_name: "",
      ref_mobile: "",
      daily_salary_entry: "",
      salary_type: "",
      salary: "",
      expiry_duration_options: "",
      report_link: "",
      show_in_ledger_when_close: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    cost: Joi.number().required().label("Cost"),
    passport_number: Joi.string().required().label("Passport"),
    identification_id: Joi.allow("").label("Emirates Id"),
    mobile: Joi.string().required().label("Mobile"),
    name: Joi.string().required().label("Name"),
    ref_name: Joi.string().label("Reference name"),
    ref_mobile: Joi.string().label("Reference mobile"),
    daily_salary_entry: Joi.number().required().label("Daily salary entry"),
    salary_type: Joi.string().allow("").label("Salary type"),
    salary: Joi.number().allow("").label("Salary"),
    expiry_duration_options: Joi.string().required().label("Renewal Duration"),
    report_link: Joi.string().allow("").label("Report Link"),
    show_in_ledger_when_close: Joi.string()
      .allow("")
      .label("show in ledger when close option"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();
      formData.append("cost", this.state.data.cost);
      formData.append("passport_number", this.state.data.passport_number);
      formData.append("identification_id", this.state.data.identification_id);
      formData.append("mobile", this.state.data.mobile);
      formData.append("name", this.state.data.name);
      formData.append("ref_name", this.state.data.ref_name);
      formData.append("ref_mobile", this.state.data.ref_mobile);
      formData.append("daily_salary_entry", this.state.data.daily_salary_entry);
      formData.append("salary_type", this.state.data.salary_type);
      formData.append("salary", this.state.data.salary);
      formData.append(
        "expiry_duration_options",
        this.state.data.expiry_duration_options
      );
      formData.append("report_link", this.state.data.report_link);
      formData.append(
        "show_in_ledger_when_close",
        this.state.data.show_in_ledger_when_close
      );

      var event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("expiry_date", date);

      event = new Date(this.state.passportExpiryDate);
      date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("passport_expiry_date", date);

      await saveSingle(formData);

      //await saveSingle(this.state.data);
      toast.success("Account has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/visas-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.cost)
          errors.cost = ex.response.data.errors.cost;

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.ref_name)
          errors.ref_name = ex.response.data.errors.ref_name;

        if (ex.response.data.errors.ref_mobile)
          errors.ref_mobile = ex.response.data.errors.ref_mobile;

        if (ex.response.data.errors.daily_salary_entry)
          errors.daily_salary_entry =
            ex.response.data.errors.daily_salary_entry;

        if (ex.response.data.errors.salary_type)
          errors.salary_type = ex.response.data.errors.salary_type;

        if (ex.response.data.errors.salary)
          errors.salary = ex.response.data.errors.salary;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  handlePassportChangeExpiry = (date) => {
    this.setState({
      passportExpiryDate: date,
    });
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/visa.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add visa account</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/visas-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add visa account</h3>
              <p>Provide the information below to add the account.</p>
              {this.renderInput("cost", "Loan", "text")}
              {this.renderInput("passport_number", "Passport", "text")}
              {this.renderInput("identification_id", "Emirates Id", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("ref_name", "Reference Name", "text")}
              {this.renderInput("ref_mobile", "Reference Mobile", "text")}
              {this.renderSelect(
                "daily_salary_entry",
                "Daily Salary Entry",
                this.state.daily_salary_options
              )}

              {this.renderSelect(
                "salary_type",
                "Salary Type",
                this.state.salary_type_options
              )}
              {this.renderInput("salary", "Salary", "text")}

              <label>Visa Renewal Date</label>

              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />

              {this.renderSelect(
                "expiry_duration_options",
                "Renewal Duration",
                this.state.expiry_duration_options
              )}

              <label>Passport Expiry Date</label>

              <DatePicker
                selected={this.state.passportExpiryDate}
                onChange={this.handlePassportChangeExpiry}
                className="input"
              />

              {this.renderSelect(
                "report_link",
                "Report Link",
                this.state.report_link_options
              )}

              {this.renderSelect(
                "show_in_ledger_when_close",
                "Show in ledger when close",
                this.state.show_in_ledger_when_close_options
              )}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default VisaForm;
